import "./styles.scss";

import { useTranslation } from "react-i18next";
import classnames from "classnames";

import { useApp } from "context/app";
import { useSettings } from "context/settings";

import DashboardContentLayout from "components/layouts/DashboardContentLayout";
import DetailsCard from "components/DetailsCard";
import DetailsCardList from "components/DetailsCardList";
import {
  ChangePasswordModal,
  PersonalDataModal,
  UserMobile,
  PasswordMobile,
} from "./components";
import ScrollTopMobile from "components/ScrollTopMobile";

import useResponsive from "libs/helpers/useResponsive";

const mainClass = "settings-layout";

const SettingsContent = ({ columns_data, columns_mobile_data }) => {
  const { websites, user } = useApp();
  const { t } = useTranslation();
  const { max } = useResponsive();

  const {
    data,
    photo_progress,
    updateSettings,
    updatePhoto,
    changePassword,
    personal_data_modal,
    change_password_modal,
    setPersonalDataModal,
    setChangePasswordModal,
  } = useSettings();

  const actions =
    user?.type === "admin"
      ? [
          {
            type: "send_notification",
          },
          {
            type: "create_task",
          },
        ]
      : user?.type === "webmaster"
        ? [
            {
              type: "send_notification",
            },
          ]
        : [
            {
              label: t("Add new website"),
              href: "/websites/new",
              event: () =>
                window.gtag("event", "new_website", {
                  click_text: t("Add new website"),
                  click_url: `/websites/new`,
                }),
            },
            ...(websites?.length > 0
              ? [
                  {
                    type: "create_client_task",
                    onboarding_button: true,
                  },
                ]
              : []),
          ];

  return (
    <>
      <DashboardContentLayout
        header={{
          label: t("Settings"),
          description: t(
            "Change your contact information, password, and more.",
          ),
        }}
        actions={actions}
        isAdaptive
      >
        <div className={mainClass}>
          {max.sm && (
            <>
              {!!columns_mobile_data?.user && (
                <div className={`${mainClass}__col`}>
                  <UserMobile {...columns_mobile_data.user} />
                </div>
              )}
              {!!columns_mobile_data?.password && (
                <div className={`${mainClass}__col`}>
                  <PasswordMobile {...columns_mobile_data.password} />
                </div>
              )}
            </>
          )}
          {columns_data?.map((data, index) => {
            const isGrouped = data?.type === "group";

            if (max.sm && data?.hiddenMobile) return null;

            return (
              <div
                key={index}
                className={classnames(`${mainClass}__col`, {
                  [`${mainClass}__col--grouped`]: isGrouped,
                  [`${mainClass}__col--notifications`]:
                    data?.title === t("Notifications"),
                })}
              >
                {isGrouped ? (
                  data?.group?.map((item, index) => (
                    <DetailsCard key={index} {...item}>
                      <DetailsCardList
                        variant={item?.listVariant}
                        items={item?.items}
                        view={item?.view}
                      />
                    </DetailsCard>
                  ))
                ) : (
                  <DetailsCard {...data}>
                    <DetailsCardList
                      variant={data?.listVariant}
                      items={data?.items}
                      view={data?.view}
                    />
                  </DetailsCard>
                )}
              </div>
            );
          })}
          {max.sm && <ScrollTopMobile />}
        </div>
      </DashboardContentLayout>

      <PersonalDataModal
        data={data}
        photo_progress={photo_progress}
        updateSettings={updateSettings}
        updatePhoto={updatePhoto}
        isOpen={personal_data_modal}
        onClose={() => setPersonalDataModal(false)}
      />
      <ChangePasswordModal
        changePassword={changePassword}
        isOpen={change_password_modal}
        onClose={() => setChangePasswordModal(false)}
      />
    </>
  );
};

export default SettingsContent;
